var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    title: "note",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-Activity"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8",
    d: "M1 10H25V31L19 37H1V10Z",
    fill: "white",
    stroke: "#285FCB",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 210",
    d: "M19 31C19 31 22.5 32 25 31C25 32.5 21.5 37 19 37C20.5 34.5 19 31 19 31Z",
    fill: "white",
    stroke: "#285FCB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24",
    x: 5,
    y: 27,
    width: 12,
    height: 3,
    fill: "#EEF1F4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 25",
    x: 5,
    y: 21,
    width: 15,
    height: 3,
    fill: "#EEF1F4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23",
    x: 5,
    y: 15,
    width: 15,
    height: 3,
    fill: "#EEF1F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 185",
    d: "M17.29 15.2175L17.4539 15.193L17.5712 15.0784L28.7611 4.1505C29.4867 3.44188 29.4867 2.29299 28.7611 1.58438C28.0355 0.875762 26.8591 0.875761 26.1335 1.58438L14.9436 12.5123L14.8263 12.6269L14.8012 12.787L14.456 14.9916L14.3519 15.6563L15.0325 15.5546L17.29 15.2175Z",
    fill: "#E1E9F8",
    stroke: "#285FCB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityNote);
export default __webpack_public_path__ + "static/media/activityNote.f1760ae0.svg";
export { ForwardRef as ReactComponent };